import { checkMethod } from "./IBarcodeScanResult";


export enum scanStatus
{
    BarcodeError,
    DoubleScan,
    ScanInAfterScanOut,
    ScanOutWithoutScanIn,
    StudentNotRegistered,
    UnknownStudent,
    ValidScan    
}


//The UI icons that correspond to each scanner type
export const ScanStatusIconMap: Record<scanStatus, string> = {
  [scanStatus.ValidScan]: 'checkmark-circle',
  [scanStatus.DoubleScan]: 'people-circle',
  [scanStatus.UnknownStudent]: 'help-circle',
  [scanStatus.StudentNotRegistered]: 'person-remove',
  [scanStatus.BarcodeError]: 'flash-off',
  [scanStatus.ScanOutWithoutScanIn]: 'exit',
  [scanStatus.ScanInAfterScanOut]: 'enter',
};

export enum ScanDirection
{
    ScanIn,
    ScanOut
}

//The UI icons that correspond to each scanner type
export const ScanDirectionIconMap: Record<ScanDirection, string> = {
  [ScanDirection.ScanIn]: 'enter',
  [ScanDirection.ScanOut]: 'exit'
};

export interface IScanItem
{
    id:string;
    scanCode: string;     //in case student was not found, is this the barcode read.
    status: scanStatus;
    direction: ScanDirection;
    date: Date;
    method: checkMethod;
    photo?: Blob;      
    examId: string;
    examStudentId?: string;
    studentId?: string;     //in case student was not registered for the exam
    synced?: boolean;
    scannerName?: string;   // voornaam + achternaam van de ingelogde gebruiker       // false/undefined = nog niet naar API verstuurd; wordt gezet door ScanHistoryService
}

